export default{

    returnArrayMiesiace(){
        return [
            {value: 1, label: 'styczeń'},
            {value: 2, label: 'luty'},
            {value: 3, label: 'marzec'},
            {value: 4, label: 'kwiecień'},
            {value: 5, label: 'maj'},
            {value: 6, label: 'czerwiec'},
            {value: 7, label: 'lipiec'},
            {value: 8, label: 'sierpień'},
            {value: 9, label: 'wrzesień'},
            {value: 10, label: 'październik'},
            {value: 11, label: 'listopad'},
            {value: 12, label: 'grudzień'},
        ]
    },

    // kierunki dla biletow miesiecznych
    returnKierunkiMiesieczne(){
        return [
            {value: 2, label: 'w obie strony', icon:'fa fa-exchange'},
            {value: 1, label: 'w jedną stronę', icon: 'fa fa-long-arrow-right'},
        ]
    },

    // statusy dla biletów miesiecznych
    returnStatusyMiesieczne(){
        return []
    },

    // okresy dla biletow miesiecznych
    returnOkresyMiesieczne(){
        return  [
                {value: "P1", label: 'pierwsza połowa'},
                {value: "P2", label: 'druga połowa'},
                {value: "M1", label: 'na cały miesiąc'},
            ]
    },

    // kolory do wykresow
    returnColorArray(){
        return [
            '#83c33a',
            '#132249',
            '#1e90ff',
            '#666666',
            '#003300',
            '#0e162a',
            '#264459',
            '#00994d',
            '#0000ca',
            '#337699',
            '#004646',
            '#333333',
            '#007700',
            '#000066',
            '#333300',


            '#c30004',
            '#491100',
            '#18ff00',
            '#310066',
            '#332500',
            '#ff8600',
            '#fff300',
            '#00994d',
            '#00ca61',
            '#608fff',
            '#ff005b',
            '#9ace61',
            '#ff3b00',
            '#00be8f',
            '#be67db',
            '#796200',
            '#ffd18b',
            '#b108ff',
            '#5f3d66',
            '#79ffb8',
            '#ffa1ad',
            '#1e081d',
            '#37236c',
            '#2e4b79',
            '#337699',
            '#48ff5b',
            '#ff2c28',
            '#a10500',
            '#84005f',
            '#b84c00',
            '#2b9f00',
            '#759772',
            '#ffff77',
            '#00ca14',
            '#ff0067',
            '#7900ff',
            '#5da877',
            '#ce6a5d',
            '#2666c7',
            '#a5ca2f',
            '#337699',
            '#620007',
            '#5f7444',
            '#ffcae2',
            '#65d3c9',
            '#161635',

        ]
    },

    returnKlientJednorazowyObject(){
        return {"idKl":1,"nrDok":"","nrTel":"","imie":"KLIENT","nazwisko":"JEDNORAZOWY","nazwiskoU":"JEDNORAZOWY","kodPoczt":"","miejscowosc":"","ulica":"","nrDomu":"","nrMieszk":"","pesel":"00000000000","email":"","emailU":"","informacje":"KLIENT JEDNORAZOWY 00000000000","imieNazwisko":"KLIENT JEDNORAZOWY","wszystko":"KLIENT JEDNORAZOWY 00000000000  "}
    },

    returnKoloryStatusow(){
        return [
            {statusvalue: -1, status: 'do opłaty', color: '#cc3337', icon: 'fa fa-times-circle-o'},
            {statusvalue: 1, status: 'opłacony', color: '#2f772a', icon: 'fa fa-check-circle-o' },
            {statusvalue: 0, status: 'rezerwacja', color: '#0077b2', icon: 'fa fa-circle-o'},
            {statusvalue: 2, status: 'skasowany', color: '#bf8517', icon: 'fa fa-circle'},
            {statusvalue: -2, status: 'anulowano kl', color: '#3a0007', icon: 'fa fa-user-times'},
            {statusvalue: -3, status: 'anulowano op', color: '#3a0007', icon: 'fa fa-user-secret'},
            {statusvalue: -4, status: 'zwrócony', color: '#302f2f', icon: 'fa fa-refresh'},
        ]
    }

}


// WEBPACK FOOTER //
// ./src/utilities/initialData/initialData.js